var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loading"},[_c('lottie',{attrs:{"options":_vm.options,"height":150,"width":150}})],1),_c('div',{staticClass:"cont-text"},[_c('h2',{staticClass:"texto-loading"},[_vm._v(_vm._s(_vm.frase))])])])}
var staticRenderFns = []

export { render, staticRenderFns }